import { useApi } from '@omnipresentgroup/api';
import type { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { useCallback } from 'react';

import { API_BASE, API_PATH } from '../constants';

export const useDocumentDownload = () => {
  const { GET } = useApi();

  const downloadDocument = useCallback(
    async ({
      documentId,
      disposition,
    }: {
      documentId: string;
      disposition?: string;
    }): Promise<{
      documentLink: string;
      status: HTTPStatusCodes;
    }> => {
      const { url: documentLink, status } = await GET<{
        url: string;
        status: HTTPStatusCodes;
      }>(
        `${API_BASE}/${API_PATH}/${documentId}/download${
          disposition ? `?disposition=${disposition}` : ''
        }`,
      );
      return { documentLink, status };
    },
    [GET],
  );

  return {
    downloadDocument,
  };
};
